var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.98,
    height: 24.293,
    viewBox: "0 0 19.98 24.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1011",
    "data-name": "Rectangle 1011",
    width: 19.981,
    height: 24.293,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bell",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2716",
    "data-name": "Group 2716",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M9.993,24.293H9.924A3.195,3.195,0,0,1,6.8,21.031l1.7.035a1.495,1.495,0,1,0,2.989.062v-.009c0-.014,0-.029,0-.044l1.7-.053c0,.048,0,.1,0,.144a3.195,3.195,0,0,1-3.192,3.126Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M18.3,20.437H1.684A1.684,1.684,0,0,1,.162,18.031,14.511,14.511,0,0,0,1.7,12.557V8.667A8.49,8.49,0,0,1,9.969,0h.042a8.489,8.489,0,0,1,8.267,8.671v3.89a14.519,14.519,0,0,0,1.54,5.47A1.684,1.684,0,0,1,18.3,20.437Zm-16.587-1.7H18.271a15.741,15.741,0,0,1-1.693-6.176V8.64A6.787,6.787,0,0,0,9.99,1.7,6.788,6.788,0,0,0,3.4,8.637v3.92A15.732,15.732,0,0,1,1.709,18.737Z",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/Bell.6fa291910516bdf70d949ae7f9f8d94f.svg";
export { ForwardRef as ReactComponent };